import React from 'react';
import {px} from '@packages/systems/core/utils/WebflowCssSubset';
import {Atom} from '@packages/systems/wfdl';
import {UsysUtilityPageConstraint} from '../utils';
import {SHARED_FORM_CONSTRAINTS_DESCENDANTS} from '@packages/systems/core/constants/SharedConstraintRules';
import {createIntegratedAtom} from '@packages/utilities/integrated-types';
import {TListOfElement} from '@packages/systems/wfdl-ast';
import {getChildren} from '@packages/utilities/data-utils';

const UserSignUpTermsOfServiceWrapper = Atom.createRender(
  ({attributes, classes, generateAttributes, data, renderChild}) => {
    return (
      // TODO: fix jsx-a11y lint error
      // eslint-disable-next-line jsx-a11y/label-has-for
      <label {...generateAttributes(attributes, classes)}>
        {getChildren(data).map((child) => renderChild(child))}
      </label>
    );
  }
);

const config = createIntegratedAtom({
  displayName: 'Terms of Service',
  constraints: {
    page: [UsysUtilityPageConstraint],
    ancestors: [
      {
        is: 'UserSignUpForm',
        rule: 'ExactlyOne',
      },
    ],
    descendants: SHARED_FORM_CONSTRAINTS_DESCENDANTS,
  },
  render: UserSignUpTermsOfServiceWrapper,
  showEmpty: true,
  style: {
    base: {
      main: {
        noPseudo: {
          display: 'flex',
          flexDirection: 'row',
          marginBottom: px(10),
        },
      },
    },
  },
  fields: {children: TListOfElement},
});

export default config;
